import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import GavelIcon from '@mui/icons-material/Gavel';

// Badge "derecho de tanteo" : affiche l'équipe (ACB) qui détient le droit.
// Pensé pour être rendu au même niveau que le badge ACB (rankings / suivis).
const TanteoBadge = ({ teamNom, compact = false }) => {
  const label = teamNom || 'Tanteo';

  return (
    <Tooltip arrow title={teamNom ? `Derecho de tanteo: ${teamNom}` : 'Derecho de tanteo'}>
      <Chip
        icon={
          <GavelIcon
            sx={{ fontSize: compact ? '0.7rem !important' : '0.85rem !important', color: '#fff !important' }}
          />
        }
        label={label}
        size="small"
        sx={{
          backgroundColor: '#f9a825',
          color: '#fff',
          fontWeight: 'bold',
          height: compact ? 18 : 22,
          fontSize: compact ? '0.65rem' : '0.75rem',
          maxWidth: 150,
          '& .MuiChip-label': {
            px: compact ? 0.5 : 0.75,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap'
          },
          '& .MuiChip-icon': { ml: 0.4 }
        }}
      />
    </Tooltip>
  );
};

export default TanteoBadge;
